import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  class: "row w-full mb-3 justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "cardbody" }
const _hoisted_4 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "title" }, "Tenant Frameworks", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.tableRow.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6)),
            _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
          ], 2)
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)),
    _createVNode(_component_tableData, {
      class: "flex-1 min-h-0 mt-5 table-section",
      tableRowData: _ctx.tableRow,
      headersData: _ctx.headers,
      loadData: _ctx.dataLoading
    }, null, 8, ["tableRowData", "headersData", "loadData"])
  ]))
}